import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeatureFlagService, FeatureFlagQuery } from '../../state';
import { FeatureFlagState } from '../../state/feature-flag.store';

interface FeatureFlagWidgetItem {
  name: string;
  value: boolean;
}

const WIDGET_FEATURE_FLAG_NAME = 'gls_2110_show_feature_flag_widget';

@Component({
  selector: 'app-feature-flag-widget',
  template: `
    <div class="feature-flag-widget" [class.hidden-widget]="hidden" *ngIf="show$ | async">
      <div class="feature-flag-widget__header">
        <span class="feature-flag-widget__header-title">FF Widget</span>
        <div class="feature-flag-widget__toggle" (click)="toggleWidget()">
          <i
            class="fa fa-icon fa-angle-double-left"
            [class.fa-angle-double-down]="!hidden"
            [class.fa-angle-double-up]="hidden"
          ></i>
        </div>
      </div>
      <ng-container *ngIf="flags$ | async as flags">
        <div class="feature-flag-widget__item" *ngFor="let flag of flags; trackBy: itemBy">
          <button (click)="toggle(flag)" [class.btn-success]="flag.value" [class.btn-default]="!flag.value" class="btn">
            {{ flag.name }}
          </button>
        </div>
      </ng-container>
    </div>
  `,
  styleUrls: ['./feature-flag-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeatureFlagWidgetComponent implements OnInit {
  flags$: Observable<Array<FeatureFlagWidgetItem>>;
  show$: Observable<boolean>;
  hidden: boolean = false;

  constructor(private route: ActivatedRoute, private query: FeatureFlagQuery, private service: FeatureFlagService) {}

  ngOnInit(): void {
    this.flags$ = this.query.selectAll().pipe(
      map((state: FeatureFlagState) =>
        Object.entries(state)
          .filter(([name]) => name !== WIDGET_FEATURE_FLAG_NAME)
          .map(([name, value]) => ({ name, value }))
      )
    );

    const featureFlagActive = this.query.getValueByKey(WIDGET_FEATURE_FLAG_NAME);

    this.show$ = this.route.queryParams.pipe(
      map(query => {
        if (!featureFlagActive) {
          return false;
        }
        return typeof query.ffwidget !== 'undefined';
      })
    );
  }

  toggle(flag: FeatureFlagWidgetItem): void {
    this.service.setValue(flag.name, !flag.value);
  }

  itemBy(_: any, item: FeatureFlagWidgetItem): string {
    return item.name;
  }

  toggleWidget(): void {
    this.hidden = !this.hidden;
  }
}
